import React from "react";
import { Circle, Group } from "react-konva";
import { useMapEditorProps } from "../../contexts/MapEditorContext";

const GUIDE_POINT_COLOR = "#9333ea"; // purple-600 — matches the pin StaticMapPinLayer
// renders for a request's pinned location elsewhere in the app.
const GUIDE_POINT_RADIUS = 8;

/**
 * Read-only marker for `MapEditorPropsState.guidePoint` — e.g. where a
 * workplace request was originally pinned, shown while an approver places a
 * new desk so they know roughly where it should go. Non-interactive
 * (`listening={false}` throughout) so it never intercepts canvas clicks.
 */
export const GuidePointOverlay: React.FC = () => {
  const { guidePoint } = useMapEditorProps();

  if (!guidePoint) return null;

  return (
    <Group listening={false}>
      <Circle
        x={guidePoint.x}
        y={guidePoint.y}
        radius={GUIDE_POINT_RADIUS * 2.5}
        fill={GUIDE_POINT_COLOR}
        opacity={0.15}
        listening={false}
      />
      <Circle
        x={guidePoint.x}
        y={guidePoint.y}
        radius={GUIDE_POINT_RADIUS}
        fill={GUIDE_POINT_COLOR}
        stroke="#ffffff"
        strokeWidth={2}
        listening={false}
      />
    </Group>
  );
};
